import React, { useState } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import TimePicker, { TimePickerProps } from 'rc-time-picker';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';

const format = 'hh:mm A';
const minuteStep = 15;

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      width: '100%',
    },
    picker: {
      zIndex: 1090,
      marginTop: 19,
      borderBottom: '1px solid #d9d9d9',
      '&.rc-time-picker': {
        //display: 'flex',
        //alignItems: 'center',
        display: 'block',
      },
      '& > .rc-time-picker-input': {
        ...theme.typography.body1,
        padding: theme.spacing(1, 0),
        backgroundColor: 'transparent',
        color: theme.palette.primary.main,
        border: 0,

        [theme.breakpoints.up('sm')]: {
          padding: theme.spacing(2, 0),
        },
        '&:focus-visible': {
          outline: 'none',
        },
      },
      '& .rc-time-picker-clear': {
        display: 'none',
      },
    },
    popup: {
      '&.rc-time-picker-panel': {
        width: 'auto',
      },
      paddingTop: 36,
      '& > .rc-time-picker-panel-inner': {
        background: theme.palette.secondary.dark,
        border: 0,
        boxShadow: 'none',
      },
      '& .rc-time-picker-panel-input-wrap': {
        display: 'none',
      },
      '& li.rc-time-picker-panel-select-option-selected': {
        background: 'rgba(255, 255, 255, 0.16)',
        fontWeight: 'normal',
      },
      '& .rc-time-picker-panel-select': {
        width: 'auto',
        maxHeight: 224,
        '& li': {
          fontSize: 16,
          padding: theme.spacing(2),
          height: 'auto',
          '&:hover': {
            background: '#585858',
            color: '#fffb00',
          },
        },
      },
    },
    icon: {
      position: 'absolute',
      right: -5,
      top: -4,
    },
    errorLine: {
      '& .rc-time-picker': {
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
    },
  }),
  { name: 'TimePicker' },
);

const StyledTimePicker: React.FC<TimePickerProps> = (props: any) => {
  const classes = useStyles(props);
  const [open, setOpen] = useState(false);
  return (
    <div className={`${classes.root} ${props.errorStatus && classes.errorLine}`}>
      <TimePicker
        {...props}
        showSecond={false}
        use12Hours
        focusOnOpen={false}
        format={format}
        value={props.value ? moment(props.value, format) : undefined}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        inputReadOnly
        open={open}
        className={classes.picker}
        popupClassName={classes.popup}
        inputIcon={open ? <ExpandLessIcon className={classes.icon} fontSize="large" /> : <ExpandMoreIcon className={classes.icon} fontSize="large" />}
        clearIcon={undefined}
        allowEmpty
        minuteStep={minuteStep}
      />
    </div>
  );
};

export default StyledTimePicker;
